module.exports = __webpack_public_path__ + "img/testMATIC.d9ff3c4d.svg";